
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ServiceAreasProps {
  locationName: string;
}

const ServiceAreas: React.FC<ServiceAreasProps> = ({ locationName }) => {
  const primaryCommunities = [
    { name: "Rocky Mount", description: "Complete residential and commercial services" },
    { name: "Wilson", description: "Full-service roofing and emergency response" },
    { name: "Tarboro", description: "Residential roofing and historic preservation" },
    { name: "Nashville", description: "Rural residential and commercial roofing" },
    { name: "Battleboro", description: "Residential services and storm damage repair" },
    { name: "Elm City", description: "Emergency services and maintenance programs" },
    { name: "Sharpsburg", description: "Residential and agricultural building roofing" },
    { name: "Whitakers", description: "Emergency services and roof repair" }
  ];

  const extendedAreas = [
    "All of Nash County",
    "All of Edgecombe County",
    "Wilson County",
    "Halifax County (southern portions)",
    "Franklin County (eastern portions)"
  ];

  return (
    <section className="mb-12">
      <h2 className="text-3xl font-bold mb-6">Our {locationName} Service Area</h2>
      
      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Primary Service Communities</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-2">
              {primaryCommunities.map((community, index) => (
                <li key={index}>
                  • <strong>{community.name}</strong> - {community.description}
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Extended Service Area</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="mb-4">We also provide emergency services and major projects throughout:</p>
            <ul className="space-y-2">
              {extendedAreas.map((area, index) => (
                <li key={index}>• {area}</li>
              ))}
            </ul>
            <div className="mt-4 p-3 bg-blue-50 rounded-lg">
              <p className="text-sm text-blue-800">
                <strong>Service Radius:</strong> 30-mile radius from our {locationName} location for regular services, extended coverage for emergencies and major projects.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ServiceAreas;
